// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getPredictions = async (
  cancel: any,
  clienteId: number[],
  vendedorId: number[],
  produtoId: number[],
  empresaId: number[],
  classificacao: string[],
  dataFim: string,
  dataInicio: string,
  page: number,
  size: number,
  segmento: string[],
  categoria: string[]
): Promise<GetPredictionsType | { message: string }> => {
  try {
    const result = await apiService.get('app/predicao', {
      cancelToken: cancel.token,
      params: {
        clienteId,
        vendedorId,
        produtoId,
        empresaId,
        classificacao,
        segmento,
        categoria,
        dataFim,
        dataInicio,
        page: page - 1,
        size,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getPredictionsHistory = async (
  id: string,
  page: number
): Promise<GetHistoryType | { message: string }> => {
  try {
    const result = await apiService.get(`app/predicao/${id}/historico`, {
      params: {
        id,
        page: page - 1,
        size: 7,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getPredictionsSoldOff = async (
  id: string,
  dataInicio: string,
  page: number
): Promise<GetSoldOffType | { message: string }> => {
  try {
    const result = await apiService.get(`app/predicao/${id}/esgotando`, {
      params: {
        id,
        dataInicio,
        page: page - 1,
        size: 5,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchDismiss = async (
  id: string | undefined,
  predicaoBaixaRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `app/predicao/${id}/baixa`,
      predicaoBaixaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'Baixa realizada com sucesso!' }
    }
    if (result.status === 201) {
      return { info: 'Produto criado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchDismissLote = async (
  id: string | undefined,
  baixas: {}[]
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(`app/predicao/${id}/baixa/lote`, {
      baixas,
    })
    if (result.status === 200) {
      return { info: 'Baixas realizadas com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Baixa em massa multi-cliente (POST app/predicao/baixa). Diferente do "enviar pedido em massa",
// baixa exatamente os produtos que aparecem na listagem: o frontend envia, por cliente, os
// produtos exibidos (produtoId + proximaCompra). Sem envio de e-mail/WhatsApp. Retorna o resumo.
export const criaBaixaEmMassa = async (
  clientes: BaixaMassaCliente[]
): Promise<BaixaMassaResultado | { message: string }> => {
  try {
    const result = await apiService.post(`app/predicao/baixa`, { clientes })
    if (result.status === 200 || result.status === 201) {
      return result.data as BaixaMassaResultado
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getPredictionsHistoryBaixa = async (
  id: string,
  page: number
): Promise<GetSoldOffType | { message: string }> => {
  try {
    const result = await apiService.get(`app/predicao/${id}/baixa/historico`, {
      params: {
        id,
        page: page - 1,
        size: 4,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const cancelarBaixa = async (
  id: string | undefined,
  predicaoBaixaRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `app/predicao/${id}/baixa/cancelar`,
      predicaoBaixaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'Baixa cancelada com sucesso!' }
    }
    if (result.status === 201) {
      return { info: 'Produto criado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchProductDetails = async (
  produtoId: number,
  id: string
): Promise<GetProductDetailPredictionType | { message: string }> => {
  try {
    const result = await apiService.get(
      `app/predicao/${id}/detalhe/${produtoId}`,
      {
        params: {
          produtoId,
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Gera o PDF de predicao do cliente no backend (GET app/predicao/{id}/pdf, application/pdf).
// dataInicio no padrao dd/MM/yyyy (mesmo do painel "Produtos esgotando"). Retorna o Blob do PDF.
export const getPredictionsPdf = async (
  id: string,
  dataInicio: string
): Promise<Blob | { message: string }> => {
  try {
    const result = await apiService.get(`app/predicao/${id}/pdf`, {
      params: {
        dataInicio,
      },
      responseType: 'blob',
    })
    if (result.status === 200) {
      return result.data as Blob
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Gera o PDF da LISTAGEM (um cliente por página) para os clientes que batem com os filtros atuais
// (GET app/predicao/pdf, application/pdf). Mesmos filtros/serialização do getPredictions.
export const getPredictionsListagemPdf = async (
  clienteId: number[],
  vendedorId: number[],
  produtoId: number[],
  empresaId: number[],
  classificacao: string[],
  dataFim: string,
  dataInicio: string,
  segmento: string[],
  categoria: string[]
): Promise<Blob | { message: string }> => {
  try {
    const result = await apiService.get('app/predicao/pdf', {
      params: {
        clienteId,
        vendedorId,
        produtoId,
        empresaId,
        classificacao,
        segmento,
        categoria,
        dataFim,
        dataInicio,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
      responseType: 'blob',
    })
    if (result.status === 200) {
      return result.data as Blob
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const fetchExportFilter = async (
  clienteId: number[],
  dataFim: string,
  dataInicio: string,
  query: string | number,
  vendedorId: number[]
): Promise<any> => {
  try {
    const result = await apiService.get('app/predicao/export', {
      params: {
        clienteId,
        dataFim,
        dataInicio,
        query,
        vendedorId,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}
